import React, {useEffect, useState} from "react";
import {Form} from "react-bootstrap";
import {BoardState} from "../../../model/BoardSearch";
import {useDispatch} from 'react-redux'
import {boardActions} from '../../../store/board'
import {useSelector} from '../../../store'


const SearchTopHtml = (props: any) => {
    const forumCode = props.forumCode;
    const [validated, setValidated] = useState(false);
    const dispatch = useDispatch();
    const store = useSelector(state => state.board);
    console.log(`searchText=${store.searchText}`);
    const [model, setModel] = useState<BoardState>(store);
    const [submitting, setSubmitting] = useState(false);

    let containerCls = 'container';
    if (forumCode === 'help') {
        containerCls += ' bloc-sm';
    }
    const submitForm = async (e: any) => {
        const isValid = e.currentTarget.checkValidity();
        if (!isValid) {
            e.preventDefault();
            e.stopPropagation();
            setValidated(true);
            return false;
        }
        e.preventDefault();
        model.categoryId=0;
        dispatch(boardActions.setSearch({...model }));
        //const form = e.target;
        console.log('parent searchFunc call');
        setSubmitting(true);
        props.searchFunc(model, function () {
            console.log(`parent searchFunc end model=${JSON.stringify(model)}`);
            setSubmitting(false);

        });

    };
    const handleInputChange = (e: any) => {
        console.log(`name=${e.target.name}, value=${e.target.value}`);
        const data = {...model, [e.target.name]: e.target.value};
        setModel(data);
    }
    useEffect(() => {
        console.log('top search');
            setModel({...model, searchText: store.searchText});
    }, [store.searchText]);

    return (
        <Form noValidate validated={validated} onSubmit={submitForm}>
            <div className="bloc l-bloc" id="bloc-14">
                <div className={containerCls}>
                    <div className="row">
                        <div className="col-lg-10 col-9">
                            <Form.Control name="searchText" className="field-style" value={model.searchText}
                                          placeholder="유사한 문의를 먼저 찾아보세요" onChange={handleInputChange}/>
                        </div>
                        <div className="col-lg-2 col-3 search-bt-area">
                            <button type="submit"
                                    className="btn btn-d btn-lg float-right search-bt float-lg-none btn-block"
                                    disabled={submitting}
                            >{submitting ? "검중.." : "검색"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Form>
    )


}

export default SearchTopHtml;
